import * as types from "./actionTypes";
import * as detailedScheduleApi from '../../api/detailedScheduleApi';

/**
 *
 */
export function fetchDetailedSchedules(
  startDate,
  endDate,
  resourceId, 
  userId
) {
  return function (dispatch) {
    return detailedScheduleApi
      .getDetailedSchedule(
        startDate,
        endDate,
        resourceId, 
        userId
      )
      .then(detailedSchedules => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_DETAILED_SCHEDULES_SUCCESS,
          detailedSchedules
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function updateDetailedScheduleParameters(parameters) {
  return function (dispatch) {
    dispatch({
      type: types.EDIT_DETAILED_SCHEDULE_PARAMETERS_SUCCESS,
      parameters
    });
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/detailedScheduleActions.js